var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDailyTraffic = function SvgDailyTraffic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "M30.55 11.385H9.671l3.82 3.82-.567.564-4.384-4.384h-.234v-.234l-.166-.166.166-.165v-.235h.235l4.383-4.383.566.565-3.819 3.818H30.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "M16 .133C24.763.133 31.867 7.237 31.867 16S24.763 31.867 16 31.867.133 24.763.133 16 7.237.133 16 .133M1.934 21.411C4.108 27.06 9.586 31.067 16 31.067c8.321 0 15.067-6.746 15.067-15.067S24.32.933 16 .933.933 7.68.933 16c0 1.608.252 3.158.72 4.611h20.502l-3.818-3.818.565-.566 4.385 4.384h.233v.234l.166.166-.165.166v.234h-.235l-4.384 4.384-.565-.566 3.818-3.818Z"
  }))));
};
export default SvgDailyTraffic;